module.exports = "https://static.wanderu.com/static/media/it.290f2fec.svg";